<template>
  <div class="__scale_matching">
    <h3>Arrange the scales to the matching descriptor</h3>
    <div class="categories">
      <div class="cat" v-for="c in categories" :key="c.id">
        {{c.name}}
        <span class="answer">
          <svg v-show="c.answer == 'correct'" viewBox="0 0 24 24" class="correct">
            <path d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z" />
          </svg>
          <svg v-show="c.answer == 'incorrect'" class="incorrect" viewBox="0 0 24 24">
            <path d="M20 6.91L17.09 4L12 9.09L6.91 4L4 6.91L9.09 12L4 17.09L6.91 20L12 14.91L17.09 20L20 17.09L14.91 12L20 6.91Z" />
          </svg>
        </span>
      </div>
    </div>
    <draggable class="start" :list="start" tag="div" :group="{ name: 'list' }">
      <div class="item" v-for="item in start" :key="item.id"><img :src="item.url"></div>
    </draggable>
    <div class="details">
      <b-button @click="checkAnswers()" type="is-primary">Check Answer</b-button>
      <br><br>
      <b-button v-show="answered" @click="reset()">Reset</b-button>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { BButton } from "buefy/src/components/button";

export default {
  name: "ScaleMatching",
  components: {
    draggable,
    BButton
  },
  data() {
    return {
      categories: [
        {
          id: 1,
          name: "Focal Resorption",
          answer: null
        },
        {
          id: 2,
          name: "Lateral Line",
          answer: null
        },
        {
          id: 3,
          name: "Regeneration",
          answer: null
        },
        {
          id: 4,
          name: "Resorption",
          answer: null
        }
      ],
      start: [],
      scales: {
        fr: [
          {
            id: 1,
            url: '/img/match/fr1.jpg'
          },
          {
            id: 2,
            url: '/img/match/fr2.jpg'
          }
        ],
        ll: [
          {
            id: 4,
            url: '/img/match/ll1.jpg'
          },
          {
            id: 5,
            url: '/img/match/ll2.jpg'
          },
          {
            id: 6,
            url: '/img/match/ll3.jpg'
          }
        ],
        rg: [
          {
            id: 7,
            url: '/img/match/rg1.jpg'
          },
          {
            id: 8,
            url: '/img/match/rg2.jpg'
          },
          {
            id: 9,
            url: '/img/match/rg3.jpg'
          }
        ],
        rs:[
          {
            id: 10,
            url: '/img/match/rs1.jpg'
          },
          {
            id: 11,
            url: '/img/match/rs2.jpg'
          },
          {
            id: 12,
            url: '/img/match/rs3.jpg'
          },
          {
            id: 13,
            url: '/img/match/rs4.jpg'
          },
        ],
      },
      answered: false, 
    };
  },
  mounted () {
    this.randomize();
  },
  methods: {
    randomize() {
      let fr = Math.floor(Math.random() * this.scales.fr.length);
      this.start.push(this.scales.fr[fr]);
      let ll = Math.floor(Math.random() * this.scales.ll.length);
      this.start.push(this.scales.ll[ll]);
      let rg = Math.floor(Math.random() * this.scales.rg.length);
      this.start.push(this.scales.rg[rg]);
      let rs = Math.floor(Math.random() * this.scales.rs.length);
      this.start.push(this.scales.rs[rs]);
      this.start.sort(() => Math.random() - 0.5);
      this.start.sort(() => Math.random() - 0.5);
    },
    reset() {
      this.start = [];
      this.randomize()
      for (let i = 0; i < this.categories.length; i++) {
        this.categories[i].answer = null;       
      }
      this.answered = false;
    },
    checkAnswers(){
      if (this.start[0].id >= this.scales.fr[0].id && this.start[0].id <= this.scales.fr[this.scales.fr.length-1].id) {
        this.categories[0].answer = 'correct';
      } else {
        this.categories[0].answer = 'incorrect';
      }
      if (this.start[1].id >= this.scales.ll[0].id && this.start[1].id <= this.scales.ll[this.scales.ll.length-1].id) {
        this.categories[1].answer = 'correct';
      } else {
        this.categories[1].answer = 'incorrect';
      }
      if (this.start[2].id >= this.scales.rg[0].id && this.start[2].id <= this.scales.rg[this.scales.rg.length-1].id) {
        this.categories[2].answer = 'correct';
      } else {
        this.categories[2].answer = 'incorrect';
      }
      if (this.start[3].id >= this.scales.rs[0].id && this.start[3].id <= this.scales.rs[this.scales.rs.length-1].id) {
        this.categories[3].answer = 'correct';
      } else {
        this.categories[3].answer = 'incorrect';
      }
      this.answered = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../theme.scss";

.__scale_matching {
  border-radius: 30px;
  box-shadow: 3px 3px 6px #ddd;
  padding: 15px;
  height: 1315px;
  width: 750px;

  .categories {
    width: 220px;
    float: left;

    .cat {
      height: 310px;
      line-height: 310px;
      font-size: 24px;
      text-align: right;
      padding-right: 15px;
      position: relative;

      .answer {
        position: absolute;
        top: -20px;
        right: 0px;
      }

      .correct {
        fill: green;
        width: 24px;
        height: 24px;
      }

      .incorrect {
        fill: red;
        width: 24px;
        height: 24px;
      }
    }
  }

  .start {
    width: 320px;
    height: 640px;
    float: left;
  }

  .details {
    width: 180px;
    padding-left: 15px;
    height: 640px;
    float: left;
  }

  .item {
    width: 300px;
    height: 300px;
    margin: 10px;
    border-radius: 15px;
    background-color: gray;

    img {
      border-radius: 15px;
    }

  }
}
</style>